"use strict";Object.defineProperty(exports, "__esModule", {value: true});var UpgradeStep; (function (UpgradeStep) {
  const PREVIEW = 'preview'; UpgradeStep["PREVIEW"] = PREVIEW;
  const SUMMARY = 'summary'; UpgradeStep["SUMMARY"] = SUMMARY;
  const BILLING = 'billing'; UpgradeStep["BILLING"] = BILLING;
})(UpgradeStep || (exports.UpgradeStep = UpgradeStep = {}));



